export const currencyFormat = (value: number) => {
	return value.toLocaleString('en-US');
};
